import { DadosAula } from './dados-aula';

export class DadosPlano {
  aula: DadosAula;

  constructor() {
    this.aula = new DadosAula();
  }
}
